import { render } from "./my.session.scan.list.vue?vue&type=template&id=2c84cd4a"
import script from "./my.session.scan.list.vue?vue&type=script&lang=js"
export * from "./my.session.scan.list.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__